export default function initImportFormDraft(form, linesSelector, label) {
    const key = form.dataset.importDraftKey;
    if (!key) return true;

    let warned = false;
    function storageWarning() {
        if (warned) return;
        warned = true;
        const warning = document.createElement("div");
        warning.className = "alert alert-danger";
        warning.textContent = `El navegador no permite conservar este borrador. Guarde ${label} antes de recargar o cerrar la pestaña.`;
        form.before(warning);
    }

    if (form.dataset.importDraftReload === "true") {
        let saved;
        try {
            saved = sessionStorage.getItem(key);
        } catch (error) {
            storageWarning();
            return false;
        }
        if (!saved) {
            window.location.replace(form.dataset.importExcelUrl);
            return false;
        }
        const csrf = form.querySelector('input[name="authenticity_token"]');
        const freshCsrf = csrf && csrf.cloneNode(true);
        form.innerHTML = saved;
        if (freshCsrf) form.prepend(freshCsrf);
    }

    function save() {
        if (!form.isConnected) return;
        const copy = form.cloneNode(true);
        const originals = form.querySelectorAll("input, textarea, select");
        const copies = copy.querySelectorAll("input, textarea, select");
        originals.forEach(function (field, index) {
            const target = copies[index];
            if (field.tagName === "TEXTAREA") {
                target.textContent = field.value;
            } else if (field.tagName === "SELECT") {
                Array.from(target.options).forEach(function (option, optionIndex) {
                    option.toggleAttribute("selected", field.options[optionIndex].selected);
                });
            } else if (field.type !== "file") {
                target.setAttribute("value", field.value);
                target.toggleAttribute("checked", field.checked);
            }
        });
        copy.querySelectorAll('input[name="authenticity_token"]').forEach(function (field) { field.remove(); });
        copy.querySelectorAll("[data-bound]").forEach(function (row) { row.removeAttribute("data-bound"); });
        try {
            sessionStorage.setItem(key, copy.innerHTML);
        } catch (error) {
            storageWarning();
        }
    }

    form.addEventListener("input", save);
    form.addEventListener("change", save);
    window.addEventListener("beforeunload", save);
    window.addEventListener("pagehide", save);
    document.addEventListener("turbolinks:before-cache", save);
    const lines = form.querySelector(linesSelector);
    if (lines) new MutationObserver(save).observe(lines, { childList: true, subtree: true });
    save();
    window.history.replaceState({}, document.title, form.dataset.importDraftUrl);
    return true;
}
